// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OGC3DTileset } from "./OGC3DTileset";
import {
  OGC3DTilesetFromJSON,
  OGC3DTilesetFromJSONTyped,
  OGC3DTilesetToJSON,
  OGC3DTilesetToJSONTyped,
} from "./OGC3DTileset";

/**
 *
 * @export
 * @interface OGC3DTilesetsMeta
 */
export interface OGC3DTilesetsMeta {
  /**
   *
   */
  tilesets: Array<OGC3DTileset>;
}

/**
 * Check if a given object implements the OGC3DTilesetsMeta interface.
 */
export function instanceOfOGC3DTilesetsMeta(value: object): value is OGC3DTilesetsMeta {
  if (!("tilesets" in value) || value["tilesets"] === undefined) return false;
  return true;
}

export function OGC3DTilesetsMetaFromJSON(json: any): OGC3DTilesetsMeta {
  return OGC3DTilesetsMetaFromJSONTyped(json, false);
}

export function OGC3DTilesetsMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OGC3DTilesetsMeta {
  if (json == null) {
    return json;
  }
  return {
    tilesets: (json["tilesets"] as Array<any>).map(OGC3DTilesetFromJSON),
  };
}

export function OGC3DTilesetsMetaToJSON(json: any): OGC3DTilesetsMeta {
  return OGC3DTilesetsMetaToJSONTyped(json, false);
}

export function OGC3DTilesetsMetaToJSONTyped(
  value?: OGC3DTilesetsMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tilesets: (value["tilesets"] as Array<any>).map(OGC3DTilesetToJSON),
  };
}
